import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const path = window.location.pathname;
  const isArabic = path === '/ar' || path.startsWith('/ar/');
  const isAdminScreen = (isArabic ? path.slice(3) : path).startsWith('/admin');
  if (isArabic && !isAdminScreen && (config.method || 'get').toLowerCase() === 'get') {
    config.params = { ...(config.params || {}), lang: 'ar' };
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAdminRoute = window.location.pathname.startsWith('/admin');
      if (isAdminRoute) {
        localStorage.removeItem('admin_token');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
